import React from "react";
import { LoaderComponent } from "@fidget/common/components/loader/loader";
import styles from "./centerPreloader.css";

export const CenterPreloader = () => (
  <div className={styles["center-preloader"]}>
    <LoaderComponent widgetStyle />
  </div>
);
